import type * as React from "react";
import { UI_VARIANT } from "@/ui/variant";
import type { UiVariant } from "@/ui/view-props";
import { useUserSettings } from "@/lib/user-settings-context";

export function UiStrategy(props: {
  classic: React.ReactNode;
  modern: React.ReactNode;
  neon?: React.ReactNode;
  variant?: UiVariant;
}) {
  const { settings, loading } = useUserSettings();
  const v = props.variant ?? settings.ui_variant ?? UI_VARIANT;
  
  // Only show spinner if we're loading AND don't have a variant yet.
  // We check if loading is true. If it is, and we don't have a forced variant
  // from props, we wait for settings to ensure we don't flicker from classic to others.
  if (loading && !props.variant) {
    return (
      <div className="flex h-[50vh] items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
      </div>
    );
  }
  
  if (v === "neon") return props.neon ?? props.classic;
  return v === "modern" ? props.modern : props.classic;
}
